<template>
    <div class="row justify-content-center px-4 pb-4">
        <div class="col-md-12 mx-auto">
            <table style="width:100%;">
                <thead>
                    <tr>
                        <th class="pr-2" style="padding-bottom:15px!important; width:33.33%; vertical-align:middle;">
                            <input type="text"
                                style="font-size:11px; width:100%; border: solid 0.5px #3A9AF3; color: #3A9AF3; border-radius: 5px;"

                                :placeholder="__('traductionview.searchbenificiaryname')"
                                v-model="filtername"
                                @change="onFilterNameChange()">
                        </th>
                        <th class="px-2" style="padding-bottom:15px!important; width:33.33%; vertical-align:middle;">
                            <input type="text"
                                style="font-size:11px; width:100%; border: solid 0.5px #3A9AF3; color: #3A9AF3; border-radius: 5px;"

                                :placeholder="__('traductionview.searchproject')"
                                v-model="filterproject"
                                @change="onFilterProjectChange()">
                        </th>
                        <th class="px-2 text-right" style="padding-bottom:15px!important;  width:33.33%; vertical-align:middle;">
                            <label for="checkbox" class="fts-12 font-weight-bold">{{__("traductionview.hide")}}</label>
                            <input type="checkbox"
                                style="font-size:11px; vertical-align:middle;"
                                id = "checkbox"
                                v-model="filterstatus"
                                @change="onFilterStatusChange()">
                        </th>
                    </tr>
                </thead>
            </table>
        </div>
        <div class="col-md-12 mx-auto dashboardstyle pt-0">
            <table class="mx-auto abc-table" style="width:100%;">
                <thead class="colorabc1 text-center fts-12" style="border-bottom: 1px solid #3A9AF3;">
                    <tr>
                        <th class="py-3" style="width:5%; vertical-align:middle;">id</th>
                        <th class="py-3" style="width:5%; vertical-align:middle;">
                            {{__("traductionpro.pays")}}
                            <button
                                style="text-align:center;"
                                type="button"
                                class="btn-sort"
                                aria-label="Tri ascendant"
                                v-on:click="countrySortAsc">
                                <svg xmlns="http://www.w3.org/2000/svg" width="9" height="9" fill="rgb(107, 107, 107)" class="bi bi-caret-up-fill" viewBox="0 0 16 16">
                                    <path d="m7.247 4.86-4.796 5.481c-.566.647-.106 1.659.753 1.659h9.592a1 1 0 0 0 .753-1.659l-4.796-5.48a1 1 0 0 0-1.506 0z"/>
                                </svg>
                            </button>
                            <button
                                style="text-align:center"
                                type="button"
                                class="btn-sort"
                                aria-label="Tri descendant"
                                v-on:click="countrySortDsc">
                                <svg xmlns="http://www.w3.org/2000/svg" width="9" height="9" fill="rgb(107, 107, 107)" class="bi bi-caret-down-fill" viewBox="0 0 16 16">
                                    <path d="M7.247 11.14 2.451 5.658C1.885 5.013 2.345 4 3.204 4h9.592a1 1 0 0 1 .753 1.659l-4.796 5.48a1 1 0 0 1-1.506 0z"/>
                                </svg>
                            </button>
                        </th>
                        <th class="text-left" style="width:15%; vertical-align:middle;">
                            {{__("traductionview.Projecttt")}}
                            <button
                                style="text-align:center;"
                                type="button"
                                class="btn-sort"
                                aria-label="Tri ascendant"
                                v-on:click="projectSortAsc">
                                <svg xmlns="http://www.w3.org/2000/svg" width="9" height="9" fill="rgb(107, 107, 107)" class="bi bi-caret-up-fill" viewBox="0 0 16 16">
                                    <path d="m7.247 4.86-4.796 5.481c-.566.647-.106 1.659.753 1.659h9.592a1 1 0 0 0 .753-1.659l-4.796-5.48a1 1 0 0 0-1.506 0z"/>
                                </svg>
                            </button>
                            <button
                                style="text-align:center"
                                type="button"
                                class="btn-sort"
                                aria-label="Tri descendant"
                                v-on:click="projectSortDsc">
                                <svg xmlns="http://www.w3.org/2000/svg" width="9" height="9" fill="rgb(107, 107, 107)" class="bi bi-caret-down-fill" viewBox="0 0 16 16">
                                    <path d="M7.247 11.14 2.451 5.658C1.885 5.013 2.345 4 3.204 4h9.592a1 1 0 0 1 .753 1.659l-4.796 5.48a1 1 0 0 1-1.506 0z"/>
                                </svg>
                            </button>
                        </th>
                        <th style="width:15%; vertical-align:middle;">
                            {{__("traductionview.status")}}
                            <button
                                style="text-align:center;"
                                type="button"
                                class="btn-sort"
                                aria-label="Tri ascendant"
                                v-on:click="statusSortAsc">
                                <svg xmlns="http://www.w3.org/2000/svg" width="9" height="9" fill="rgb(107, 107, 107)" class="bi bi-caret-up-fill" viewBox="0 0 16 16">
                                    <path d="m7.247 4.86-4.796 5.481c-.566.647-.106 1.659.753 1.659h9.592a1 1 0 0 0 .753-1.659l-4.796-5.48a1 1 0 0 0-1.506 0z"/>
                                </svg>
                            </button>
                            <button
                                style="text-align:center"
                                type="button"
                                class="btn-sort"
                                aria-label="Tri descendant"
                                v-on:click="statusSortDsc">
                                <svg xmlns="http://www.w3.org/2000/svg" width="9" height="9" fill="rgb(107, 107, 107)" class="bi bi-caret-down-fill" viewBox="0 0 16 16">
                                    <path d="M7.247 11.14 2.451 5.658C1.885 5.013 2.345 4 3.204 4h9.592a1 1 0 0 1 .753 1.659l-4.796 5.48a1 1 0 0 1-1.506 0z"/>
                                </svg>
                            </button>
                        </th>
                        <th style="width:10%; vertical-align:middle;">
                            {{__("traductionview.benif")}}
                            <button
                                style="text-align:center;"
                                type="button"
                                class="btn-sort"
                                aria-label="Tri ascendant"
                                v-on:click="beneficiarySortAsc">
                                <svg xmlns="http://www.w3.org/2000/svg" width="9" height="9" fill="rgb(107, 107, 107)" class="bi bi-caret-up-fill" viewBox="0 0 16 16">
                                    <path d="m7.247 4.86-4.796 5.481c-.566.647-.106 1.659.753 1.659h9.592a1 1 0 0 0 .753-1.659l-4.796-5.48a1 1 0 0 0-1.506 0z"/>
                                </svg>
                            </button>
                            <button
                                style="text-align:center"
                                type="button"
                                class="btn-sort"
                                aria-label="Tri descendant"
                                v-on:click="beneficiarySortDsc">
                                <svg xmlns="http://www.w3.org/2000/svg" width="9" height="9" fill="rgb(107, 107, 107)" class="bi bi-caret-down-fill" viewBox="0 0 16 16">
                                    <path d="M7.247 11.14 2.451 5.658C1.885 5.013 2.345 4 3.204 4h9.592a1 1 0 0 1 .753 1.659l-4.796 5.48a1 1 0 0 1-1.506 0z"/>
                                </svg>
                            </button>
                        </th>
                        <th style="width:20%; vertical-align:middle;">
                            To-Do
                            <button
                                style="text-align:center;"
                                type="button"
                                class="btn-sort"
                                aria-label="Tri ascendant"
                                v-on:click="todoSortAsc">
                                <svg xmlns="http://www.w3.org/2000/svg" width="9" height="9" fill="rgb(107, 107, 107)" class="bi bi-caret-up-fill" viewBox="0 0 16 16">
                                    <path d="m7.247 4.86-4.796 5.481c-.566.647-.106 1.659.753 1.659h9.592a1 1 0 0 0 .753-1.659l-4.796-5.48a1 1 0 0 0-1.506 0z"/>
                                </svg>
                            </button>
                            <button
                                style="text-align:center"
                                type="button"
                                class="btn-sort"
                                aria-label="Tri descendant"
                                v-on:click="todoSortDsc">
                                <svg xmlns="http://www.w3.org/2000/svg" width="9" height="9" fill="rgb(107, 107, 107)" class="bi bi-caret-down-fill" viewBox="0 0 16 16">
                                    <path d="M7.247 11.14 2.451 5.658C1.885 5.013 2.345 4 3.204 4h9.592a1 1 0 0 1 .753 1.659l-4.796 5.48a1 1 0 0 1-1.506 0z"/>
                                </svg>
                            </button>
                        </th>
                        <th style="width:15%; vertical-align:middle;">{{__("traductionview.categorie")}}
                             <button
                                style="text-align:center;"
                                type="button"
                                class="btn-sort"
                                aria-label="Tri ascendant"
                                v-on:click="ProjCatSortAsc">
                                <svg xmlns="http://www.w3.org/2000/svg" width="9" height="9" fill="rgb(107, 107, 107)" class="bi bi-caret-up-fill" viewBox="0 0 16 16">
                                    <path d="m7.247 4.86-4.796 5.481c-.566.647-.106 1.659.753 1.659h9.592a1 1 0 0 0 .753-1.659l-4.796-5.48a1 1 0 0 0-1.506 0z"/>
                                </svg>
                            </button>
                            <button
                                style="text-align:center"
                                type="button"
                                class="btn-sort"
                                aria-label="Tri descendant"
                                v-on:click="ProjCatSortDsc">
                                <svg xmlns="http://www.w3.org/2000/svg" width="9" height="9" fill="rgb(107, 107, 107)" class="bi bi-caret-down-fill" viewBox="0 0 16 16">
                                    <path d="M7.247 11.14 2.451 5.658C1.885 5.013 2.345 4 3.204 4h9.592a1 1 0 0 1 .753 1.659l-4.796 5.48a1 1 0 0 1-1.506 0z"/>
                                </svg>
                            </button>
                        </th>
                        <th style="width:10%; vertical-align:middle;">
                            {{__("traductionview.startedon")}}
                            <button
                                style="text-align:center;"
                                type="button"
                                class="btn-sort"
                                aria-label="Tri ascendant"
                                v-on:click="startdateSortAsc">
                                <svg xmlns="http://www.w3.org/2000/svg" width="9" height="9" fill="rgb(107, 107, 107)" class="bi bi-caret-up-fill" viewBox="0 0 16 16">
                                    <path d="m7.247 4.86-4.796 5.481c-.566.647-.106 1.659.753 1.659h9.592a1 1 0 0 0 .753-1.659l-4.796-5.48a1 1 0 0 0-1.506 0z"/>
                                </svg>
                            </button>
                            <button
                                style="text-align:center"
                                type="button"
                                class="btn-sort"
                                aria-label="Tri descendant"
                                v-on:click="startdateSortDsc">
                                <svg xmlns="http://www.w3.org/2000/svg" width="9" height="9" fill="rgb(107, 107, 107)" class="bi bi-caret-down-fill" viewBox="0 0 16 16">
                                    <path d="M7.247 11.14 2.451 5.658C1.885 5.013 2.345 4 3.204 4h9.592a1 1 0 0 1 .753 1.659l-4.796 5.48a1 1 0 0 1-1.506 0z"/>
                                </svg>
                            </button>
                        </th>
                        <th style="width:10%; vertical-align:middle;">
                            {{__("traductionview.duedate")}}
                            <button
                                style="text-align:center;"
                                type="button"
                                class="btn-sort"
                                aria-label="Tri ascendant"
                                v-on:click="deadlineSortAsc">
                                <svg xmlns="http://www.w3.org/2000/svg" width="9" height="9" fill="rgb(107, 107, 107)" class="bi bi-caret-up-fill" viewBox="0 0 16 16">
                                    <path d="m7.247 4.86-4.796 5.481c-.566.647-.106 1.659.753 1.659h9.592a1 1 0 0 0 .753-1.659l-4.796-5.48a1 1 0 0 0-1.506 0z"/>
                                </svg>
                            </button>
                            <button
                                style="text-align:center"
                                type="button"
                                class="btn-sort"
                                aria-label="Tri descendant"
                                v-on:click="deadlineSortDsc">
                                <svg xmlns="http://www.w3.org/2000/svg" width="9" height="9" fill="rgb(107, 107, 107)" class="bi bi-caret-down-fill" viewBox="0 0 16 16">
                                    <path d="M7.247 11.14 2.451 5.658C1.885 5.013 2.345 4 3.204 4h9.592a1 1 0 0 1 .753 1.659l-4.796 5.48a1 1 0 0 1-1.506 0z"/>
                                </svg>
                            </button>
                        </th>
                    </tr>
                </thead>
                <tbody id="ongoingproject" class="text-center" style="font-size: 11px; display:block; height:max-content; max-height:500px; overflow:auto; margin-right:2px!important; margin-left:3px!important;">
                    <tr v-for="(customer, index) in customs" :key="index" style="border-bottom: 1px solid rgb(206,206,206);">
                        <td class="" style="vertical-align: middle; width:5%;">
                            {{ customer.id }}
                        </td>
                        <td class="" style="vertical-align: middle; width:5%;">
                            {{ customer.country.name }}
                        </td>
                        <td v-if="customer.type =='beneficiary'" class="text-left py-2" style="vertical-align: middle; width:15%;">
                            <!-- <a :href="'/app/home/show/project/customer/' + customer.beneficiary_id+ '/' +customer.id+ '/' +customer.country.id" class="font-weight-bold colorabc1 triggerspinner"> -->
                            <a :href="'/app/home/show/project/customer/' + customer.beneficiary_id+ '/' +customer.id" class="font-weight-bold colorabc1 triggerspinner">
                            {{ customer.name }}
                            </a>
                        </td>
                        <td v-if="customer.type =='corporate'" class="text-left py-2" style="vertical-align: middle; width:15%;">
                            <a v-if="pro.super_pro ==1" :href="'/app/pro/ongoing/show/'+customer.id+ '/' +customer.beneficiary_id+ '/' +customer.country.id" class="font-weight-bold colorabc1 triggerspinner">
                                {{ customer.name }}
                            </a>
                            <a v-else :href="'/app/pro/ongoing/show/'+customer.id+ '/' +pro.id+ '/' +customer.country.id" class="font-weight-bold colorabc1 triggerspinner">
                                {{ customer.name }}
                            </a>
                        </td>
                        <td v-if="customer.type =='CEO'" class="text-left py-2" style="vertical-align: middle; width:15%;">
                            <a v-if="pro.super_pro ==1" :href="'/app/pro/ongoing/show/'+customer.id+ '/' +customer.beneficiary_id+ '/' +customer.country.id" class="font-weight-bold colorabc1 triggerspinner">
                                {{ customer.name }}
                            </a>
                            <a v-else :href="'/app/pro/ongoing/show/'+customer.id+ '/' +pro.id+ '/' +customer.country.id" class="font-weight-bold colorabc1 triggerspinner">
                                {{ customer.name }}
                            </a>
                        </td>
                        <td style="vertical-align: middle; width:15%;">
                            {{ Math.round(customer.progress_computed) }}% completed
                        </td>
                        <td v-if="customer.type =='beneficiary'" style="vertical-align: middle; width:10%;" class="py-3">
                            <a :href="'/app/home/' + customer.beneficiary_id" class="font-weight-bold colorabc1 triggerspinner">
                            {{ customer.beneficiary }}
                            </a>
                        </td>
                        <td v-if="customer.type =='corporate'" style="vertical-align: middle; width:10%;" class="py-3">
                            <a v-if="pro.super_pro ==1" :href="'/app/home/company/open'+ '/' +customer.beneficiary_id + '/' +customer.country.id" class="font-weight-bold colorabc1 triggerspinner">
                                {{ customer.beneficiary }}
                            </a>
                            <a v-else :href="'/app/home/company/open'+ '/' +pro.id + '/' +customer.country.id" class="font-weight-bold colorabc1 triggerspinner">
                                {{ customer.beneficiary }}
                            </a>
                        </td>
                        <td v-if="customer.type =='CEO'" style="vertical-align: middle; width:10%;" class="py-3">
                            <a v-if="pro.super_pro ==1" :href="'/app/home/pro/my_projects'+ '/' +customer.beneficiary_id + '/' +customer.country.id" class="font-weight-bold colorabc1 triggerspinner">
                                {{ customer.beneficiary }}
                            </a>
                            <a v-else :href="'/app/home/pro/my_projects'+ '/' +pro.id + '/' +customer.country.id" class="font-weight-bold colorabc1 triggerspinner">
                                {{ customer.beneficiary }}
                            </a>
                        </td>
                        <td v-if="customer.detail_documents !=0" style="vertical-align: middle; width:20%;">
                            {{ customer.detail_documents }} document(s) to upload.
                        </td>
                        <td v-else style="vertical-align: middle; width:20%;">
                            <p  class="mb-0 py-1">
                                {{__("traductionview.nothing")}}
                            </p>
                        </td>
                        <td style="vertical-align: middle; width:15%;">
                                {{ customer.business_line }}
                        </td>
                        <td style="vertical-align: middle; width:10%;">
                               {{ customer.start_date }}
                        </td>
                        <td style="vertical-align: middle; width:10%;">
                            {{ customer.deadline }}
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>
    export default {
        props: [
            'customers',
            'pro',
            'token',
            'route',
        ],

        data() {
            return {
                customs:[],
                filtername:"",
                filterproject:"",
                filterstatus:"",
            }
        },

        mounted() {
            this.customers.forEach(customer =>
            {
                this.customs.push(customer)
            });
        },

        methods: {
            onFilterNameChange(){
                this.customs=[];
                this.customers.forEach(customer =>
                {
                    var search = customer.beneficiary.toLowerCase()
                    if (search.includes(this.filtername.toLowerCase()))
                    {
                        this.customs.push(customer);
                    }
                });

            },
            onFilterProjectChange(){
                this.customs=[];
                this.customers.forEach(customer =>
                {
                    var search = customer.name.toLowerCase()
                    if (search.includes(this.filterproject.toLowerCase()))
                    {
                        this.customs.push(customer);
                    }
                });

            },
            onFilterStatusChange(){
                this.customs=[];
                if (this.filterstatus)
                {
                    this.customers.forEach(customer =>
                    {
                        if (customer.progress_computed < "100")
                        {
                            this.customs.push(customer);
                        }
                    });

                }
                else
                {
                    this.customers.forEach(customer =>
                    {
                        this.customs.push(customer);
                    })
                }
            },
            projectSortAsc(){

                this.customs = this.customs.sort(function(a, b){
                    if (a.name < b.name)
                    {
                        return -1;
                    }
                    else if (a.name > b.name)
                    {
                        return 1;
                    }
                    else
                    {
                        return 0;
                    }
                });
            },

            projectSortDsc(){
                this.customs = this.customs.sort(function(a, b){
                    if (a.name > b.name)
                    {
                        return -1;
                    }
                    else if (a.name < b.name)
                    {
                        return 1;
                    }
                    else
                    {
                        return 0;
                    }
                });
            },
            ProjCatSortAsc(){

                this.customs = this.customs.sort(function(a, b){
                    if (a.business_line < b.business_line)
                    {
                        return -1;
                    }
                    else if (a.business_line > b.business_line)
                    {
                        return 1;
                    }
                    else
                    {
                        return 0;
                    }
                });
            },

            ProjCatSortDsc(){
                this.customs = this.customs.sort(function(a, b){
                    if (a.business_lineS > b.business_line)
                    {
                        return -1;
                    }
                    else if (a.business_line < b.business_line)
                    {
                        return 1;
                    }
                    else
                    {
                        return 0;
                    }
                });
            },
            beneficiarySortAsc(){
                this.customs = this.customs.sort(function(a, b){
                    if (a.beneficiary < b.beneficiary)
                    {
                        return -1;
                    }
                    else if (a.beneficiary > b.beneficiary)
                    {
                        return 1;
                    }
                    else
                    {
                        return 0;
                    }
                });
            },
            beneficiarySortDsc(){
                this.customs = this.customs.sort(function(a, b){
                    if (a.beneficiary > b.beneficiary)
                    {
                        return -1;
                    }
                    else if (a.beneficiary < b.beneficiary)
                    {
                        return 1;
                    }
                    else
                    {
                        return 0;
                    }
                });
            },
            todoSortAsc(){
                this.customs = this.customs.sort(function(a, b){
                    if (a.detail_documents < b.detail_documents)
                    {
                        return -1;
                    }
                    else if (a.detail_documents > b.detail_documents)
                    {
                        return 1;
                    }
                    else
                    {
                        return 0;
                    }
                });
            },
            todoSortDsc(){
                this.customs = this.customs.sort(function(a, b){
                    if (a.detail_documents > b.detail_documents)
                    {
                        return -1;
                    }
                    else if (a.detail_documents < b.detail_documents)
                    {
                        return 1;
                    }
                    else
                    {
                        return 0;
                    }
                });
            },
            statusSortAsc(){
                this.customs = this.customs.sort(function(a, b){
                    if (a.progress_computed < b.progress_computed)
                    {
                        return -1;
                    }
                    else if (a.progress_computed > b.progress_computed)
                    {
                        return 1;
                    }
                    else
                    {
                        return 0;
                    }
                });
            },
            statusSortDsc(){
                this.customs = this.customs.sort(function(a, b){
                    if (a.progress_computed > b.progress_computed)
                    {
                        return -1;
                    }
                    else if (a.progress_computed < b.progress_computed)
                    {
                        return 1;
                    }
                    else
                    {
                        return 0;
                    }
                });
            },
            startdateSortAsc(){
                this.customs = this.customs.sort(function(a, b){
                    if (a.start_date < b.start_date)
                    {
                        return -1;
                    }
                    else if (a.start_date > b.start_date)
                    {
                        return 1;
                    }
                    else
                    {
                        return 0;
                    }
                });
            },
            startdateSortDsc(){
                this.customs = this.customs.sort(function(a, b){
                    if (a.start_date > b.start_date)
                    {
                        return -1;
                    }
                    else if (a.start_date < b.start_date)
                    {
                        return 1;
                    }
                    else
                    {
                        return 0;
                    }
                });
            },
            countrySortAsc(){

                this.customs = this.customs.sort(function(a, b){
                    if (a.country < b.country)
                    {
                        return -1;
                    }
                    else if (a.country > b.country)
                    {
                        return 1;
                    }
                    else
                    {
                        return 0;
                    }
                });
            },

            countrySortDsc(){
                this.customs = this.customs.sort(function(a, b){
                    if (a.country > b.country)
                    {
                        return -1;
                    }
                    else if (a.country < b.country)
                    {
                        return 1;
                    }
                    else
                    {
                        return 0;
                    }
                });
            },
            deadlineSortAsc(){
                this.customs = this.customs.sort(function(a, b){
                    if (a.deadline < b.deadline)
                    {
                        return -1;
                    }
                    else if (a.deadline > b.deadline)
                    {
                        return 1;
                    }
                    else
                    {
                        return 0;
                    }
                });
            },
            deadlineSortDsc(){
                this.customs = this.customs.sort(function(a, b){
                    if (a.deadline > b.deadline)
                    {
                        return -1;
                    }
                    else if (a.deadline < b.deadline)
                    {
                        return 1;
                    }
                    else
                    {
                        return 0;
                    }
                });
            },
        }
}

</script>